// canonical definitions of frontend related things for CompanyToDo

const companyToDoTypes = [
  // array of objects for different types of ToDos to be added -- easier to define here than in template
  // used in multiple places -- for 'add new' and for showing list of what's already added
  {
    key: 'formium_form', // must be unique on this list
    title: 'Form', // for display
    category: 'formium_form', // should exactly match what you use as RfxCompanyToDo.category on backend
    subcategory: null, // only on certain types, for further categorization
    description: 'Create a custom form for vendors to complete.',
    icon: 'ui-checks',
    default_title: 'Question List', // default title used when adding new one
    canClone: true, // whether or not this type can be cloned (backend must support it)
  },
  {
    key: 'quotesheet',
    title: 'Quote Sheet',
    category: 'quotesheet',
    subcategory: null, // only on certain types, for further categorization
    description: 'Get detailed price quotes on a list of items.',
    icon: 'table',
    default_title: 'Quote Sheet', // default title used when adding new one
    canClone: true, // whether or not this type can be cloned (backend must support it)
  },
  {
    key: 'docrequest_upload',
    title: 'Document Upload',
    category: 'docrequest',
    subcategory: 'upload', // only on certain types, for further categorization
    description: 'Ask vendors to upload a file.',
    icon: 'cloud-upload',
    default_title: 'Document Upload', // default title used when adding new one
    canClone: true, // whether or not this type can be cloned (backend must support it)
    options: {
      dr_type: 'upload',
    },
  },
  {
    key: 'docrequest_template',
    title: 'Document Template',
    category: 'docrequest',
    subcategory: 'template', // only on certain types, for further categorization
    description: 'Ask vendors to fill out a template or file, provided by you.',
    icon: 'file-earmark-spreadsheet',
    default_title: 'Document to Complete', // default title used when adding new one
    canClone: true, // whether or not this type can be cloned (backend must support it)
    options: {
      dr_type: 'template',
    },
  },
  {
    key: 'smartform',
    title: 'Quote Template',
    category: 'smartform',
    subcategory: null, // only on certain types, for further categorization
    description: 'Use a custom quote template.',
    icon: 'file-spreadsheet',
    default_title: '', // leave blank, we get it from selected template instead
    canClone: true, // whether or not this type can be cloned (backend must support it)
  },
  /* {
        key: "quoteworksheet_template",
        title: "Quote Worksheet Template",
        category: "quoteworksheet",
        description: "Ask vendors to fill out a quote worksheet template.",
        icon: "file-spreadsheet",
        default_title: "Quote Worksheet to Complete",
        options: {
            dr_type: "template",
        },
    }, */
  /* {  // JUST FOR TESTING NEW QUOTE WORKSHEETS - CALCULATED FORMS
        key: 'quote_worksheet',
        title: 'Quote Worksheet',
        category: 'worksheet',
        description: 'A saved quote worksheet template.',
        icon: 'file-earmark-spreadsheet',
        default_title: 'Quote Worksheet',  // default title used when adding new one
    }, */
];

const companyToDoTypesMapping = Object.fromEntries(companyToDoTypes.map((typ) => [typ.key, typ]));
// makes a single object with all companyToDoTypes, keyed by 'key'

function getCompanyToDoTypeByCategory(category, subcategory) {
  // subcategory is optional -- but if provided, must match exactly
  return companyToDoTypes.find((typ) => typ.category === category && (subcategory ? typ.subcategory === subcategory : true));
}

export { companyToDoTypes, companyToDoTypesMapping, getCompanyToDoTypeByCategory };
